
import {Contract, assetList, carAsset, ToKenDef, userBalance,  Recipe,  userInfos, SessionData, GameServer, GameConfig, StatMod, SYSDef, AppInfos, phantomAPP} from './definitions';

import { getCarSA, getCarAA, buyNitroWax, getRecipesSA, getUserInfosWax,  getBalanceWax, getDamagesWax, getDamageWax, getAssetsSA, getAssetsAA, demo_cars_wax, unmountAccessSA, unmountAccessAA, eraseNitroWax, mountAccessSA, mountAccessAA, initUserDataWax, modStatWax, checkquestWax } from "./actionsWax";
import { getCarMX,getGarageCar, buyNitroSolana,  getUserInfosMX,  getBalanceSolana, getDamageMX, getAssetsMX, getDamagesMX, demo_cars, unmountAccessMX, mountAccessMX, initUserDataMX, modStatSolana, resetGarageSlotSolana, mintGarageSlotSolana } from "./actionsSol.ts";

import {  cars, getMotor, getTire } from '../assets/js/cc.js';
import base58_to_binary from './crypto/base58_to_binary.ts';

export const WCW = 0, ANCHOR=1, PHANTOM=2, PHANTOMAPP=3, BACKPACK=4, BACKPACKAPP=5;
export const BC_WAX =0, BC_SOLANA = 1;

function defHandler(e: any){ return true;}

type EventFunc = (e: any) => boolean;


export class DomEvents {

    onMouseMove:EventFunc;
    onMouseDown:EventFunc;
    onMouseUp:EventFunc;
    onTouchMove:EventFunc;
    onTouchEnd:EventFunc;
    onKeyDown:EventFunc; 
    onKeyUp:EventFunc;
    constructor(){
        
        this.onMouseMove=defHandler;
        this.onMouseDown=defHandler;
        this.onMouseUp=defHandler;
        this.onTouchMove=defHandler;
        this.onTouchEnd=defHandler;
        this.onKeyDown=defHandler;
        this.onKeyUp=defHandler;
    }
}

export type BlockchainInfos = {
    phantomInfos:phantomAPP;
    cfg_seed:string;
    sessID:string;
    MintKey:string| null;
    nitros_seed:string| null;
    myAccount:string| null;
    logType:number;
    seed:string;
    selectedCarid:string;
    selectedCartype:number;
    network:string;
    testnet:boolean; 
    localnet:boolean; 
    validated:boolean; 
    siteURL:string;
    bc_type: number;
    garage_seed:string;
    mainContract:string;
    TK:ToKenDef;
    SA:Contract;
    AA:Contract;
    MX:Contract;
    SYS:SYSDef;
    GameKey :string;
    DemoContractDef:Contract | null;
    assetLists : assetList;

    gid : number;
    gameServer : GameServer;
    endpoints:Array<string>

    gameServers:Array<GameServer>

    baseAddr:string;
    chainId:string;
    waxEndPT:string;  
    solanaEndPT:string;
}

/*
    let balanceCurrent : userBalance | null= null;
    let setBalanceCurrent : any= null;
    let userInfosCurrent : userInfos | null= null;
    let setuserInfosCurrent : any= null;

    export function setBalanceState(balance:userBalance | null){
        balanceCurrent=balance;
        setBalanceCurrent(balance);
    }
    
    export function setUserInfosState(userInfos:userInfos | null){
        userInfosCurrent=userInfos;
        setuserInfosCurrent(userInfos);
    }

    export function getBalanceState():userBalance{

        return balanceCurrent === null ? {stl : '0.00', main : '0.00'} : balanceCurrent;
    }

    export function getUserinfosState():userInfos{

        return userInfosCurrent === null ? {quests : 0, techBalance : 0, nitros: 0, bluePrints:0} : userInfosCurrent;
    }

    export function getOrSetBalanceState(balance : userBalance | null, setBalance : any):userBalance| null{

        if(balanceCurrent === null){
            balanceCurrent = balance;
        }

        if(setBalanceCurrent === null){
            setBalanceCurrent = setBalance;
        }
        return balanceCurrent;
    }
    


    export function getOrSetUserinfos(userInfos : userInfos, setuserInfos : any){

        if(userInfosCurrent === null){
            userInfosCurrent = userInfos;
        }

        if(setuserInfosCurrent === null){
            setuserInfosCurrent = setuserInfos;
        }
        return [userInfosCurrent,setuserInfosCurrent];
    }
    
    */

    export async function getRecipes(infos:BlockchainInfos, bluePrints = 0):Promise<Array<Recipe> | null>{

        switch(infos.bc_type){
            case BC_WAX:return await getRecipesSA(infos.SA, infos.mainContract, bluePrints);break;
        }

        return null;
    }


    export async function resetGarageSlot(infos:BlockchainInfos, cat:string, n:number){

        switch(infos.bc_type){
            case BC_SOLANA:resetGarageSlotSolana(infos, cat, n);
        }
    }

    export async function mintGarageSlot(infos:BlockchainInfos, slot:number, slot_type:number){

        switch(infos.bc_type){
            case BC_SOLANA:mintGarageSlotSolana(infos, slot, slot_type);break;
        }
    }

    export function checkquest(infos:BlockchainInfos, assetid : string, assettype: number){

        switch(infos.bc_type){
            case BC_SOLANA:break;
            case BC_SOLANA:checkquestWax(infos, assetid, assettype);

        }

    }

    export async function getCar(infos:BlockchainInfos,id : string , type: number, account:string | null = null): Promise<carAsset | null>{        
        var asset = null;

        for (let n = 0; n < cars.length; n++) {
            if (parseInt(cars[n].id) == parseInt(id)) {
                var ret = cars[n];
                ret.motor = getMotor(ret.motorid);
                ret.suspension = getTire(ret.tireid);
                return ret;
            }
        }

        if(!infos.network)
            return null;

        console.log('getCar:'+type);

        switch (type) {
            case -2:

                if(infos.network.startsWith('solana'))
                    asset = await getCarMX(id, account !== null ? account: infos.myAccount, infos.TK, infos.MX);
                else
                    asset = await getCarSA(infos.SA.collectionName, parseInt(id), infos.mainContract, infos.SA.contract, infos.SA.collectionName );

                if(asset !== null){
                    asset.type = -2;
                    asset.isDemo = true;
                }
            break;            
            case 0:
                asset = await getCarSA( account !== null ? account: infos.myAccount, parseInt(id), infos.mainContract, infos.SA.contract, infos.SA.collectionName );
                break;
            case 1:
                asset = await getCarAA( account !== null ? account: infos.myAccount, parseInt(id), infos.mainContract, infos.AA.contract, infos.AA.collectionName );
                break;
            case 2:
                asset = await getGarageCar( account !== null ? account: infos.myAccount, infos.mainContract, infos.garage_seed, 0, infos.TK, infos.MX);
            break;                
            case 3:
            case 4:
                asset = await getCarMX(id,  account !== null ? account: infos.myAccount , infos.TK, infos.MX);
            break;                

        }

        /*
        if(asset && asset.suspension){
            asset.suspension.width *= 2;
            asset.suspension.radius *= 2;
        }
        */
                        
        return asset;
    }

    export async  function getDemoCarsMX(infos:BlockchainInfos){

        const dcars = infos.testnet ? demo_cars.testnet : demo_cars.mainnet;

            for(let id of dcars){
                const car = await getCarMX(id, infos.myAccount, infos.TK, infos.MX);
                if(!car)
                    continue;

                car.isDemo = true;
                car.type = -2;
                infos.assetLists['cars'].push(car);
            }
        }


        export async  function getDemoCarsSM(infos:BlockchainInfos){

            
            const cars = infos.testnet ? demo_cars_wax.testnet : demo_cars_wax.mainnet;

            for(let id of cars){
                const car = await getCarSA(infos.SA.collectionName, id, infos.mainContract, infos.SA.contract, infos.SA.collectionName);
                if(!car)
                    continue;

                car.isDemo = true;
                car.type = -2;
                infos.assetLists.cars.push(car);
            }
        }
        export async function getDemoCars(infos:BlockchainInfos){

            if(!infos.network)
                return;
            
            if(infos.network.startsWith('solana'))
                await getDemoCarsMX(infos);
            else
                await getDemoCarsSM(infos);

        }
        

    

    
    export async function getUserBalance(infos:BlockchainInfos):Promise<userBalance>{

        if(infos.myAccount == null)
            return {stl : "--", main : "--"};

        switch(infos.bc_type){
            case BC_WAX:
                return await getBalanceWax(infos.myAccount, infos.mainContract);
            break;
            case BC_SOLANA:
                if(infos.MintKey == null)
                    return {stl : "--", main : "--"};
                
                return await getBalanceSolana(infos);
            break;

            default:
                return {stl : "--", main : "--"};
        }

    }

    
    export async function getUserInfos(infos:BlockchainInfos): Promise<userInfos | null>  {
          if(infos.myAccount == null)
            return null;

                    
        switch(infos.bc_type){
            case BC_WAX:return await getUserInfosWax(infos.myAccount, infos.mainContract); break;
            case BC_SOLANA: if((infos.nitros_seed == null)||(infos.MintKey == null)) return null; return await getUserInfosMX(infos.myAccount, infos.mainContract, infos.nitros_seed); break;
            default:return {techBalance:0.0, bluePrints:0.0, nitros:0.0, quests:0.0};break;
        }
    }

    export async function getDamage(infos:BlockchainInfos, icar:carAsset|null, update: number) {

        if(infos.myAccount == null)
            return 0;

        if(infos.MintKey == null)
            return 0;

        if(icar === null)
            return 0;

        switch(icar.type){
            case 0:case 1:await getDamageWax(icar, infos.mainContract, update);break;
            case 2:case 3:await getDamageMX(infos.myAccount, infos.GameKey, infos.mainContract, icar, update);break;

        }
    }

    
    export async function getAssets(infos:BlockchainInfos, categories:Array<string>, type: number = 3): Promise<assetList | null> {

        if (!infos.myAccount)
            return null;
    
        if(type & 1)
            await getAssetsSA(infos.assetLists, infos.myAccount, categories, infos.SA.contract, infos.SA.collectionName);

        if(type & 2)
            await getAssetsAA(infos.assetLists, infos.myAccount, categories, infos.AA.contract, infos.AA.collectionName);

        if(type & 4)
            await getAssetsMX(infos.assetLists,infos.myAccount, categories, infos.garage_seed, infos.mainContract, infos.MX, infos.TK );


        if (infos.assetLists['cars'].length>0) {

            switch(infos.bc_type)
            {
                case BC_WAX:await getDamagesWax(infos.assetLists, infos.mainContract);break;
                case BC_SOLANA:await getDamagesMX(infos.assetLists, infos.myAccount, infos.GameKey, infos.mainContract);break;
            }
        }

        return infos.assetLists;
    }

    
    export async function getTires(infos:BlockchainInfos,type:number) {
        let assets = null;

        try {
            let t;
            switch(type){
                case 3:case 2: t = 4;break;
                case 0: t = 1;break;
                case 1: t = 2;break;
            }
            
            assets = await getAssets(infos,['tires'], t);
        }
        catch (e:any) {
            alert('getTires error ' + e.message);
            //$('#item-list').html('getTires : error ' + e.message);
            return;
        }

        if (assets === null) {
            //$('#item-list').html('cannot load assets');
            return;
        }
    }

    
    export async function getMotors(infos:BlockchainInfos,type:number) {


        let assets = null;
        let t;

        switch(type) {
            case 3:case 2: t = 4;break;
            case 0: t = 1;break;
            case 1: t = 2;break;
        }
        try {            
            assets = await getAssets(infos,['motors'], t);
        }
        catch (e:any) {
            alert('getMotors error ' + e.message);
            //$('#item-list').html('getMotors error ' + e.message);
            return;
        }

        /*
        $('#item-list').html('');
        $('#motor-tab').prop('disabled', false);

        if (!infos.assetLists.hasOwnProperty('motors')) {
            $('#item-list').html('no motors');
            return;
        }

        if (infos.assetLists['motors'].length === 0) {
            $('#item-list').html('no motors');
            return;
        }

        */

        
    }

    export async function getBatteries(infos:BlockchainInfos,type:number){

        let assets = null;
        let t;

        switch(type) {
            case 3:case 2: t = 4;break;
            case 0: t = 1;break;
            case 1: t = 2;break;
        }
        try {            
            assets = await getAssets(infos,['batteries'], t);
        }
        catch (e:any) {
            alert('getBatteries error ' + e.message);
            //$('#item-list').html('getBatteries error ' + e.message);
            return;
        }

    }

    export async function getRadars(infos:BlockchainInfos,type:number){


        let assets = null;
        let t;

        switch(type) {
            case 3:case 2: t = 4;break;
            case 0: t = 1;break;
            case 1: t = 2;break;
        }
        try {            
            assets = await getAssets(infos,['radars'], t);
        }
        catch (e:any) {
            alert('getRadars error ' + e.message);
            //$('#item-list').html('getRadars error ' + e.message);
            return;
        }


    }

    
    export async function getWeapons(infos:BlockchainInfos,type:number) {

        let assets = null;

        try {
            let t;
            switch(type){
                case 3:case 2: t = 4;break;
                case 0: t = 1;break;
                case 1: t = 2;break;
            }
            
            assets = await getAssets(infos,['weapons'], t);
        }
        catch (e:any) {
            alert('getWeapons error ' + e.message);
            //$('#item-list').html('getWeapons : error ' + e.message);
            return;
        }

        if (assets === null) {
            //$('#item-list').html('cannot load assets');
            return;
        }

    }

            
    export type selectedCar={
        id:string;
        type:number;
    }


    //session.account?session.account : 'guest', session.logtype, session.carid, session.cartype, session.network, appInfos.testnet, appInfos.mainContract, appInfos.AA, appInfos.SA, appInfos.MX, appInfos.TK, appInfos.garage_seed, appInfos.gameKey, appInfos.mintKey, appInfos.nitros_seed, d
    export function getBlockchainInfos(appInfos: AppInfos,session:SessionData):BlockchainInfos{
        
        const gid = session ? session.gameserverid !== null ? session.gameserverid : 0 : 0;
        

        return {
            DemoContractDef : session.logtype == WCW || session.logtype == ANCHOR ? appInfos.SA : appInfos.MX,
            phantomInfos: { 
                sharedPK : session.sharedpk.length > 0 ? base58_to_binary(session.sharedpk ) : new Uint8Array(), 
                sharedSk: session.sharedsk.length >0 ?base58_to_binary(session.sharedsk ): new Uint8Array(), 
                phantomPK :session.phantompk && session.phantompk.length>0 ? base58_to_binary( session.phantompk ): new Uint8Array(), 
                phantomSession : session.phantomsession,
                siteURL:appInfos.baseAddr
             },
            myAccount : session.account,
            logType : session.logtype ,
            selectedCarid :  session.carid,
            selectedCartype : session.cartype ,
            network : session.network,
            sessID : session.idh ,
            seed: session.seed,
            siteURL : appInfos.baseAddr,
            validated : session ? session.validated : false,
            gameServers:appInfos.gameServers,
            bc_type: appInfos.bc_type,
            testnet : appInfos.testnet,
            localnet : appInfos.localnet,
            cfg_seed : appInfos.cfg_seed,
            MintKey : appInfos.mintKey,
            nitros_seed : appInfos.nitros_seed,
            garage_seed : appInfos.garage_seed,
            mainContract :appInfos.mainContract,
            TK :appInfos. TK,
            SA :appInfos.SA,
            AA :appInfos.AA,
            MX :appInfos.MX,
            SYS :appInfos.SYS,
            GameKey :appInfos.gameKey,
            assetLists : {cars : [], tires : [], motors : [], radars : [], batteries : [], weapons : []},
            gid : gid,
            gameServer : appInfos.gameServers[gid],
            endpoints: appInfos.endpoints,
            baseAddr:appInfos.baseAddr,
            chainId:appInfos.chainId,
            waxEndPT:appInfos.waxEndpoint,
            solanaEndPT:appInfos.solEndPts,
            
        }
    }
    export async function unmountAccess(blockchainfos:BlockchainInfos, carid:string, type:number, cat:string, name:string) {

        switch (type) {
            case 0: return await unmountAccessSA(blockchainfos, carid, cat, name);
            case 1: return await unmountAccessAA(blockchainfos, carid, cat, name);
            case 2: return await unmountAccessMX(blockchainfos, cat, name);
        }
    }
    export async function mountAccess(blockchainfos:BlockchainInfos, carid:string, type:number, aid:string, acessType:number = 0) {

        switch (type) {
            case 0: return await mountAccessSA(blockchainfos, carid, aid);
            case 1: return await mountAccessAA(blockchainfos, carid, aid);
            case 2: return await mountAccessMX(blockchainfos, aid, acessType);
        }
    }


    
    export async function initUserData(blockchainfos:BlockchainInfos){
        
        switch(blockchainfos.bc_type){
            case BC_WAX:await initUserDataWax(blockchainfos); break;
            case BC_SOLANA:await initUserDataMX(blockchainfos); break;
        }
    }

    
    export async function  buyNitros(blockchainfos:BlockchainInfos, GameConfig:GameConfig, n:number) {
        if (n <= 0)
            return;

        switch(blockchainfos.bc_type){
            case BC_WAX:await buyNitroWax(blockchainfos, n, GameConfig); break;
            case BC_SOLANA: await buyNitroSolana(blockchainfos, n); break;
        }

    }

    export async function eraseNitro(blockchainfos:BlockchainInfos){
        if(blockchainfos.myAccount == null)
            return null;

                    
        switch(blockchainfos.logType){
            case BC_WAX:return await eraseNitroWax(blockchainfos); break;
            case BC_SOLANA: break;
            default:return null;break;
        }
    }
    

    export async function modStat(blockchainfos:BlockchainInfos, gameConfig:GameConfig, statMods:StatMod) {

        switch(blockchainfos.selectedCartype){
            case 0:case 1:await modStatWax(blockchainfos, gameConfig, blockchainfos.selectedCarid, blockchainfos.selectedCartype, statMods);break;
            case 2:await modStatSolana(blockchainfos, statMods);break;
            case 3:alert('park car first ! ');
        }

    }

export type globalUserInfos = {
    balance:userBalance;
    userInfos:userInfos | null;
}


export function hasCar(session:SessionData) {

    if ((session.cartype == 2) || (session.cartype == -2))
      return true;


    if((session.cartype ==0)||(session.cartype ==1)){

        const carid = parseInt(session.carid);
        if (carid <= 0)
          return false;

        /*
        if (((freecars.indexOf(carid) < 0))&&(!session.validated))
            return false;
        */
    }


    return true;
  }